module.exports = __webpack_public_path__ + "img/workflows.d14a51ff.png";